import CaicCellSwitch from './src/CaicCellSwitch.vue'
const CellSwitch = {
  install: function (Vue) {
    Vue.component(CaicCellSwitch.name, CaicCellSwitch)
  }
}
export default CellSwitch



// WEBPACK FOOTER //
// ./src/cell-switch/index.js